// Module
var code = "<div id=\"V-E9A9961F-74A5-480E-86C9-DF54D666F4E7\"> <h6>Create New</h6> </div> ";
// Exports
export default code;